const pathName = "";

export interface IUrlRedirection {
  navigationName: string;
  label: string;
  name: string;
  url: string;
  tab?: string;
}

export const urls: IUrlRedirection[] = [
  {
    navigationName: "dns",
    label: "new-paiement-dns",
    name: "Paiement dns",
    url: "/dns/paiements",
  },
  {
    navigationName: "dns",
    label: "new-declaration-dns",
    name: "Déclaration dns",
    url: "/dns",
  },
  {
    navigationName: "formation",
    label: "formation",
    name: "Formation",
    url: "/planning/formations",
  },
  {
    navigationName: "sensibilisation",
    label: "sensibilisation",
    name: "Sensibilisation",
    url: "/planning/sensibilisation",
  },
  {
    navigationName: "vets",
    label: "vets",
    name: "Visite d'établissement",
    url: "/planning/visites",
  },
  {
    navigationName: "carnet",
    label: "new-carnet-consultation",
    name: "Carnet de consultation",
    url: "/bulletin-consultation",
  },
  {
    navigationName: "rdv-specialiste",
    label: "rdv-specialiste",
    name: "Rendez-vous spécialiste",
    url: "/rdv-specialist",
  },
  {
    navigationName: "rendez-vous-exeptionnel",
    label: "rendez-vous-exeptionnel",
    name: "Rendez-vous exeptionnel",
    url: "/liste-rdv",
  },
  {
    navigationName: "visite-embauche",
    label: "visite-embauche",
    name: "Visite d'embauche",
    url: "/planning/visites",
  },
  {
    navigationName: "visite-systematique",
    label: "visite-systematique",
    name: "Visite systématique",
    url: "/planning/vmo",
  },
  {
    navigationName: "visite-persuasion",
    label: "visite-persuasion",
    name: "Visite de persuasion",
    url: "/planning/visites",
  },
  {
    navigationName: "secourisme",
    label: "secourisme",
    name: "Secourisme",
    url: "/planning/visites",
  },
  {
    navigationName: "cva",
    label: "cva",
    name: "Contre visite d' aptitude",
    url: "/planning/visites",
  },
  {
    navigationName: "crt",
    label: "crt",
    name: "Contre visite d' aptitude",
    url: "/planning/visites",
  },
  {
    navigationName: "vmr",
    label: "vmr",
    name: "Visite médicale renforcée",
    url: "/planning/visites",
  },
  {
    navigationName: "visite-speciale",
    label: "visite-speciale",
    name: "Visite spéciale",
    url: "/planning/visites",
  },
  {
    navigationName: "vra",
    label: "vra",
    name: "Visite de retraite anticipé",
    url: "/planning/visites",
  },
  {
    navigationName: "demande-particuliere",
    label: "demande-particuliere",
    name: "Demande particulière",
    url: "/planning/visites",
  },
  {
    navigationName: "reclamation",
    label: "new-reclamation",
    name: "Réclamation",
    url: "/reclamations",
  },
  {
    navigationName: "avis-adherent",
    label: "new-adherent-avis",
    name: "Avis adhérent",
    url: "/avis",
  },
  {
    navigationName: "bo-user",
    label: "new-bo-user",
    name: "Inscription utilisateur",
    url: "/users/assigner",
  },
  {
    navigationName: "avis-embauche-debauche",
    label: "avis-embauche-debauche",
    name: "Avis embauche / débauche",
    url: "/avis-embauche-debauche",
  },
];
